import cx from 'classnames';
import React from 'react';
export const FormFeedback = ({ className, feedbackText, feedbackTextProps, helperText, helperTextProps, ...rest }) => (React.createElement("div", { className: cx('tds-form-feedback', className), ...rest },
    React.createElement("div", { className: "tds-form-helper-text", ...helperTextProps }, helperText),
    React.createElement("div", { className: "tds-form-feedback-text", ...feedbackTextProps }, feedbackText)));
